export default __webpack_public_path__ + "static/Booking-bg-27d0eee37f775ffee961acbe388aab1d.png";